module.exports = __webpack_public_path__ + "img/login.a739280c.png";